import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';
import { State, getCurrentUser } from '../../../../../store';
import { HeaderNavigation } from '../header-navigation.types';

export const accountNavigationLoader: HeaderNavigation.Loader = () => {
  const store$ = inject<Store<State>>(Store);
  const user$ = store$.select(getCurrentUser);

  return user$.pipe(
    map((user) => {
      const children: HeaderNavigation.Item[] = [
        ...(user?.OktaUsername__c?.length
          ? [
              {
                label: 'Manage Account',
                pathname: '/manage/account',
                prefixIcon: 'manage_accounts',
                ariaLabel: 'Navigate to manage account',
              },
            ]
          : []),
        {
          label: 'Sign Out',
          prefixIcon: 'logout',
          pathname: '/logout',
          ariaLabel: 'Sign out',
        },
      ];
      return {
        label: 'User Menu',
        prefixIcon: 'user-cb',
        isSvg: true,
        ariaLabel: 'User menu dropdown',
        children,
      };
    }),
  );
};
